import PropTypes from 'prop-types';
import { Component, cloneElement } from 'react';
import { connect } from 'react-redux';
import lodash from 'lodash';

import { loadDataSourceItems } from 'common/actions/dataSources';

class DataSourceValueLoader extends Component {
    componentDidMount() {
        this.reloadDataItems();
    }

    componentDidUpdate(prevProps) {
        if (!lodash.isEqual(this.props.dataSourceIds, prevProps.dataSourceIds)) {
            this.reloadDataItems();
        }
    }

    reloadDataItems() {
        const { dataSourceIds } = this.props;
        this.props.loadDataSourceItems(dataSourceIds);
    }

    render() {
        const { dataSourceItems } = this.props;
        return cloneElement(this.props.children, { dataSourceItems });
    }
}

DataSourceValueLoader.propTypes = {
    dataSourceId: PropTypes.string,
    dataSourceIds: PropTypes.arrayOf(PropTypes.string),
    dataSourceItems: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.any.isRequired,
        text: PropTypes.string.isRequired,
        dataType: PropTypes.string.isRequired,
        order: PropTypes.number.isRequired
    })),
    children: PropTypes.element.isRequired
};

export default connect((state, {dataSourceId, dataSourceIds}) => {
    if (!lodash.isNil(dataSourceId) && !lodash.isNil(dataSourceIds)) {
        throw new Error('Must only use dataSourceId or dataSourceIds, and not both.');
    }
    const finalDataSourceIds = dataSourceId ? [dataSourceId] : dataSourceIds;
    const dataSourceItems = lodash.reduce(finalDataSourceIds, (dataItems, dsId) => {
        const nextItems = lodash.get(state, ['dataSourceItems', dsId], []);
        return [...dataItems, ...nextItems];
    }, []);

    return {
        dataSourceIds: finalDataSourceIds,
        dataSourceItems
    };
}, {
    loadDataSourceItems
})(DataSourceValueLoader);